export const getApiErrorMessage = (
	apiError: unknown,
	fallbackMessage: string
) => {
	if (typeof apiError === "object" && apiError !== null) {
		const error = apiError as {
			msg?: unknown;
			data?: unknown;
			response?: {
				data?: unknown;
				statusText?: unknown;
			};
			message?: unknown;
			statusText?: unknown;
		};

		if (
			typeof error.msg === "string" &&
			error.msg.trim().length > 0
		) {
			return error.msg;
		}

		const candidatePayloads = [
			error.response?.data,
			error.data,
		];

		for (const payload of candidatePayloads) {
			if (
				typeof payload === "string" &&
				payload.trim().length > 0
			) {
				return payload;
			}

			if (typeof payload === "object" && payload !== null) {
				const parsedPayload = payload as {
					msg?: unknown;
					error?: unknown;
					message?: unknown;
				};

				if (
					typeof parsedPayload.msg === "string" &&
					parsedPayload.msg.trim().length > 0
				) {
					return parsedPayload.msg;
				}

				if (
					typeof parsedPayload.error === "string" &&
					parsedPayload.error.trim().length > 0
				) {
					return parsedPayload.error;
				}

				if (
					typeof parsedPayload.message === "string" &&
					parsedPayload.message.trim().length > 0
				) {
					return parsedPayload.message;
				}
			}
		}

		if (
			typeof error.response?.statusText === "string" &&
			error.response.statusText.trim().length > 0
		) {
			return error.response.statusText;
		}

		if (
			typeof error.message === "string" &&
			error.message.trim().length > 0
		) {
			return error.message;
		}

		if (
			typeof error.statusText === "string" &&
			error.statusText.trim().length > 0
		) {
			return error.statusText;
		}
	}

	return fallbackMessage;
};
